import React, { useState, useEffect, useRef} from 'react';
import { Button, Input, Modal, Checkbox } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const TextInputWithPopup = ({ imageUrl, submitEvent }) => {
  const [text, setText] = useState('');
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isTextValid, setIsTextValid] = useState(false); // Hozzáadott állapot a szöveg hosszának ellenőrzéséhez
  const [doNotShowAgain, setDoNotShowAgain] = useState(JSON.parse(localStorage.getItem('doNotShowAgain')) || false);
  const inputRef = useRef(null); // Létrehozunk egy új ref-et

  useEffect(() => {
    localStorage.setItem('doNotShowAgain', doNotShowAgain);
  }, [doNotShowAgain]);

  useEffect(() => {
    // Ha az inputRef létezik, akkor fókuszáljuk az input elemet
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []); 

  const showModal = () => {
    if (!doNotShowAgain) {
      setVisible(true);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleDisplayText = () => {
    if (text.length >= 3) {
      if (doNotShowAgain) {
        submitEvent(text); // Automatically call submitEvent if the checkbox is checked
      } else {
        setConfirmationVisible(true); // Show modal if the checkbox is not checked
      }
    } else {
      setIsTextValid(false);
    }
  };

  const handleConfirmationOk = () => {
    setConfirmationVisible(false);
    submitEvent(text);
  };

  const handleConfirmationCancel = () => {
    setConfirmationVisible(false);
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    setText(newText);
    setIsTextValid(newText.length >= 3);
  };

  const handleDoNotShowAgainChange = (e) => {
    setDoNotShowAgain(e.target.checked);
  };

  const handleKeyPress = (e) => {
    // Ellenőrizzük, hogy az Enter billentyű lett-e lenyomva
    if (e.key === 'Enter' && isTextValid) {
      handleDisplayText();
    }
  };

  return (
      <div style={{ textAlign: 'center', margin: '20px' }}>
      <Input
        ref={inputRef}
        value={text}
        onChange={handleTextChange}
        onKeyDown={handleKeyPress} 
        placeholder="Enter your story"
        style={{ width: '100%' }}
      />
      {!isTextValid && (
        <div style={{ color: 'red', marginTop: '5px' }}>
          Your story is too short!
        </div>
      )}
      <div style={{ margin: '20px' }}>
        <Button
          type="primary"
          onClick={handleDisplayText}
          style={{ width: '100%' }}
          disabled={!isTextValid} // Inaktív, ha a szöveg nem érvényes
        >
          Submit
        </Button>
      </div>
      <img src={imageUrl} alt="Preview" style={{ maxWidth: '100%', cursor: 'pointer' }} onClick={showModal} />
      <Modal
        title="Are you sure about this?"
        open={confirmationVisible}
        onOk={handleConfirmationOk}
        onCancel={handleConfirmationCancel}
        okText="Confirm"
        cancelText="No"
      >
        <p>If you're sure, go ahead and confirm, but you won't be able to change what you've decided!</p>
        <Checkbox
          checked={doNotShowAgain}
          onChange={handleDoNotShowAgainChange}
        >
          Do not show this again
        </Checkbox>
      </Modal>
    </div>
  );
};

export { TextInputWithPopup };
